import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import Helpers, { number_format } from "../../../../../config/Helpers";

import axios from "axios";

const postUrlLogin  = API_URL + "widgets";

class Totals extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            result_rows : (<div></div>),
            total_widgets : { 
                room_nights_by_widget_ly     : 0, 
                room_nights_by_widget  : 0, 
                room_nights_budget_by_widget : 0,
                room_nights_bb_by_widget     : 0 
            },
            totals_general : 0,
            plans : ""
        }
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    getRow(wdg_aux, filt, index, title = true){
        return filt !== "totals" ? 
        <div key={"list-room-night-"+index} className={ index%2 ? "row-c" : "" }>
        <div>{ number_format(wdg_aux[filt].total_room_nights) }</div>
        <div>${ number_format(wdg_aux[filt].adr_books, 2) }</div>
        <div>${ number_format(wdg_aux[filt].total_reservations) }</div>
        </div>
    :   <div className={"datagrid-month " + (title === true ? "totals" : (index%2 ? "row-c" : ""))}>
            <div>{ number_format(wdg_aux[filt].room_nights_by_widget) }</div>
            <div>${ number_format(wdg_aux[filt].adr_books_by_widget, 2) }</div>
            <div>${ number_format(wdg_aux[filt].revenue_by_widget) }</div>
        </div>
    }
    componentWillReceiveProps(props){
        const
            has_statics_channels  = (Object.keys(this.props.statics_channels).length > 0),
            has_statics_segments  = (Object.keys(this.props.statics_segments).length > 0),
            has_statics_time      = (Object.keys(this.props.statics).length > 0),
            has_totals_channels   = (Object.keys(this.props.total_widgets_channels).length > 0)

        let plans, result_rows;
        let wdg_aux = [], totals_general = "";

        wdg_aux["channels"] = this.props.statics_channels; 
        wdg_aux["segments"] = this.props.statics_segments; 
        wdg_aux["trimester"] = this.props.statics_trimester; 
        wdg_aux["months"] = this.props.statics; 
        
        if(Object.keys(wdg_aux).length > 0){
            this.state.plans = Object.keys(this.props.statics).map((value_plan, index_plan) => {
                let key_times = this.props.layout.state.segmentActive;
                if(value_plan === 'Totals'){
                    result_rows = Object.keys(wdg_aux["months"][value_plan]).map((filt, index) => {
                        
                        if(has_statics_channels){
                            if(wdg_aux["channels"][filt] !== undefined){
                                const wdg = wdg_aux["channels"][filt];
                                return Object.keys(wdg).map((filt_aux, index_aux) => {
                                    if(filt_aux !== "totals"){
                                        let channel_list = wdg[filt_aux];
                                        if(key_times[filt_aux] !== undefined){
                                            return Object.keys(channel_list).map((filt_channel, index_channel) => {
                                                return this.getRow(channel_list, filt_channel, index_aux)
                                            })
                                        }else{
                                            return this.getRow(wdg[filt_aux], "totals", index_aux, false)
                                        }
                                    }else{
                                        return this.getRow(wdg, filt_aux, index_aux)
                                    }
                                })
                            }
                        }   
                        if(has_statics_segments){
                            if(wdg_aux["segments"][filt] !== undefined){
                                const wdg = wdg_aux["segments"][filt];
                                return Object.keys(wdg).map((filt_aux, index_aux) => {
                                    if(filt_aux === "totals"){
                                        return this.getRow(wdg, filt_aux, index_aux)
                                    }else{
                                        return this.getRow(wdg, filt_aux, index_aux)
                                    }
                                })
                            }
                        }
                        if(has_statics_time){
                            return this.getRow(wdg_aux["months"][value_plan], filt, index)
                        }
                    })
                    return (
                        <div className={"datagrid-widget widget-result  " + this.props.hidden_wdg_room_nights}>
                            <div className="container-fluid">
                                <div className="row header-widget">
                                    <div className="col-md-12 options-widget">
                                        <span className="title">{value_plan}</span>
                                        {/*<span className="opt remove-widget" onClick={this.activeWdg.bind(this, "room-nights")}>
                                            <img src={DeleteFilter} />
                                        </span>*/}
                                    </div>
                                </div>
                                <div className="current-values">
                                    <div className="row">
                                        <div className="col-md-12 head-current">
                                            <span>RNS</span>
                                            <span>ADR</span>
                                            <span>REV</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 datagrid-list">
                                            { result_rows }
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    )
                }
            });
        }

        this.setState({ total_widgets : this.props.total_widgets });
    }
    render(){    
        return (this.state.plans)
    }
};
export default Totals



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Reserves/Totals.js